import { Injectable } from '@angular/core';
import { CustomIconService } from './Global/custom-icon.service';
import { JitsiLoadService } from '../modules/shared/Services/jitsi-load.service';

/**
 * CoreInitializationService
 *
 * Centralizes critical application initialization that must run before any component renders.
 * This service is called via APP_INITIALIZER to ensure icons, external scripts, and other
 * critical setup is complete before the app starts.
 */
@Injectable({ providedIn: 'root' })
export class CoreInitializationService {
    private initialized = false;

    constructor(
        private customIconService: CustomIconService,
        private jitsiLoadService: JitsiLoadService
    ) {}

    /**
     * Initialize all critical app-wide services.
     * This method is idempotent - calling it multiple times has no effect after first call.
     */
    initialize(): void {
        if (this.initialized) {
            return;
        }
        this.initialized = true;

        // Register all custom SVG icons with Material Icon Registry
        this.customIconService.init();

        // Preload Jitsi external API script for video meetings
        this.jitsiLoadService.preloadJitsi().then(() => {
            // Jitsi script loaded successfully
        }).catch((error) => {
            console.error('Failed to preload Jitsi script:', error);
        });
    }

    /**
     * Check if initialization has been completed
     */
    isInitialized(): boolean {
        return this.initialized;
    }
}
